<template>
  <v-app>
   <Header />
    <router-view />
    <Footer/>
  </v-app>
</template>

<script>
import Header from "./components/Common/header";
import Footer from "./components/Common/footer";
import "./assets/styles/font.css";
import "./assets/styles/style.css";
export default {
  name: 'App',

  components: {
    Header,
Footer
  },

  data: () => ({
    //
  }),
};
</script>
